<mat-sidenav-container>

  <mat-sidenav-content [ngClass]="sidenavRef?.opened ? 'sidenav-opened':'sidenav-closed'">
    @if ((renderNav$ | async)) {
      <div
        class="mobile-top-bar d-flex align-items-center d-lg-none" (scroll)="onScrollEvent($event)"
        [ngClass]=" {'fixed' : (scrollOffset > 0)} ">
        <div class="col p-0 d-flex" (click)="sidenavRef?.toggle()">
          <button mat-icon-button><i class="fas fa-bars"></i></button>
        </div>
        <div class="col col-auto text-center" (click)="sidenavRef?.toggle()">
          <img src="/assets/img/dx-kulture-logo.svg" style="height: 24px;">
        </div>
        <div class="col p-0 text-right">
          <button mat-mini-fab color="primary" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" class="mat-elevation-z0">
            <i class="fal fa-user"></i>
          </button>
        </div>
      </div>
    }
    @if ((renderNav$ | async)) {
      <div class="app-topbar d-none d-lg-flex align-items-center">
        <ctv-sidenav-button></ctv-sidenav-button>
        <span class="app-topbar-divider"></span>
        <ctv-breadcrumbs [items]="(breadcrumbItems$ | async)"></ctv-breadcrumbs>
      </div>
    }
    <main class="main" [ngClass]="(renderNav$ | async) ? null : 'main--fullscreen'">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>

  <mat-menu #menu="matMenu" class="mat-menu--account">
    <!--          <button mat-menu-item [routerLink]="'/users/accounts'">-->
    <button mat-menu-item>
      <i class="fal fa-user-circle"></i>
      <span class="mr-3">{{ user?.name}}</span>
    </button>
    @if (publishers) {
      <mat-divider></mat-divider>
    }
    @if (publishers) {
      <button mat-menu-item disabled>
        <span>Switch Account</span>
      </button>
    }
    <div>
      @for (pub of publishers; track pub) {
        <span>
          <button mat-menu-item (click)="openDashboard('publisher', pub.id)">
            <span class="ml-2">{{pub.name}}</span>
          </button>
        </span>
      }
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="openChangePasswordDialog()" class="">
      <i class="fal fa-cogs"></i>
      <span class="ml-n1">Change password</span>
    </button>
    <button mat-menu-item [routerLink]="'/sessions'" class="">
      <i class="fal fa-laptop"></i>
      <span class="ml-n1">Manage Devices</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="openPrivacyChoices()">
      <i class="fal fa-shield-check"></i>
      <span class="ml-n1">Privacy choices</span>
    </button>
    <button mat-menu-item (click)="logout()" class="">
      <i class="fal fa-sign-out"></i>
      <span>Sign Out</span>
    </button>
  </mat-menu>

  @if ((renderNav$ | async)) {
    <mat-sidenav [mode]="(screenWidth > 992) ? 'side' : 'over'" [opened]="isSideNavOpened$ | async"
      [class.sideOpened]="isSideNavOpened$ | async" [class.sideClosed]="(isSideNavOpened$ | async) === false"
      [class.nav-campaigns-active]="isCampaignsNavActive()" #sidenav>
      <div class="sidenav-logo-header">
        @if (user.network?.id === '3') {
          @if (isSideNavOpened$ | async) {
            <img class="sidenav-logo-img" src="../assets/img/logo-3.png" alt="">
          } @else {
            <img class="sidenav-logo-img sidenav-logo-img--collapsed" src="../assets/img/logo-small-3.png" alt="">
          }
        } @else {
          <img class="sidenav-logo-img" src="/assets/img/dx-kulture-logo.svg" alt="DX Kulture">
        }
      </div>
        <div class="sidenav-menu">
          <!-- NETWORK USER -->
          @if (UI.isNetworkUser) {
            <mat-accordion class="app-nav-accordion" #accordionNetwork="matAccordion" [multi]="false">
              @if (UI.isNetworkUser) {
                <div (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
                    <span class="nav-icon nav-icon--dashboard" matTooltip="Dashboard"></span>
                    <span>Dashboard</span>
                  </a>
                </div>
                <div *csHasPermission="[RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ]" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <a class="sidenav-menu-item" routerLink="/ai-insights" routerLinkActive="active">
                    <span class="nav-icon nav-icon--ai-insights" matTooltip="AI Insights"></span>
                    <span>AI Insights</span>
                    <ctv-ai-insights-unread-badge></ctv-ai-insights-unread-badge>
                  </a>
                </div>
              }
              @if (UI.isNetworkUser) {
                <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="sidenav-menu-item" >
                      <span class="nav-icon nav-icon--supply" matTooltip="Inventory"></span>
                      <span>Inventory</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                    <li>
                      <a routerLink="/placements" routerLinkActive="active">
                        <i class="fal fa-th-large" matTooltip="Placements"></i>
                        <span>Placements</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/audio-supply" routerLinkActive="active">
                        <i class="fal fa-headphones" matTooltip="Audio Supply"></i>
                        <span>Audio Supply</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/display-supply" routerLinkActive="active">
                        <i class="fal fa-desktop" matTooltip="Display Supply"></i>
                        <span>Display Supply</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/supply-search" routerLinkActive="active">
                        <i class="fal fa-search" matTooltip="Supply Search"></i>
                        <span>Supply Search</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/supply-upload" routerLinkActive="active">
                        <i class="fal fa-file-upload" matTooltip="Bulk Upload"></i>
                        <span>Bulk Upload</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/apps" routerLinkActive="active">
                        <i class="fal fa-mobile-alt" matTooltip="Apps"></i>
                        <span>Apps</span>
                      </a>
                    </li>
                    <li>
                      <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
                        <i class="fal fa-bullseye" matTooltip="Targeting"></i>
                        <span>Targeting</span>
                      </a>
                    </li>
                    <li>
                      <a [routerLink]="['/', AppRoutePath.BLOCK_LIST]" routerLinkActive="active">
                        <i class="fal fa-ban" matTooltip="Block List"></i>
                        <span>Block List</span>
                      </a>
                    </li>
                    <li>
                      <a routerLinkActive="active"
                        routerLink="/ads-txt">
                        <i class="fal fa-file-alt" matTooltip="Ads.txt"></i>
                        <span>Ads.txt</span>
                      </a>
                    </li>
                  </ul>
                </mat-expansion-panel>
              }
              @if (UI.isNetworkUser) {
                <div (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels()">
                  <a class="sidenav-menu-item" routerLink="/publishers" routerLinkActive="active">
                    <span class="nav-icon nav-icon--publishers" matTooltip="Publishers"></span>
                    <span>Publishers</span>
                  </a>
                </div>
              }
              @if (UI.isNetworkUser) {
                <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="sidenav-menu-item">
                      <span class="nav-icon nav-icon--demand"></span>
                      Demand
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                    <li>
                      <a routerLinkActive="active" routerLink="/demand/list">
                        <i class="fal fa-handshake" matTooltip="Partners"></i>
                        <span>Partners</span>
                      </a>
                    </li>
                    <li>
                      <a routerLinkActive="active" routerLink="/connections">
                        <i class="fal fa-plug" matTooltip="Connections"></i>
                        <span>Connections</span>
                      </a>
                    </li>
                    <li>
                      <a routerLinkActive="active" routerLink="/deals">
                        <i class="fal fa-file-invoice-dollar" matTooltip="Deals"></i>
                        <span>Deals</span>
                      </a>
                    </li>
                  </ul>
                </mat-expansion-panel>
              }
              @if (UI.isNetworkUser) {
                <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="sidenav-menu-item">
                      <span class="nav-icon nav-icon--campaign" matTooltip="Campaigns"></span>
                      Campaigns
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                    <li>
                      <a routerLink="/advertiser" routerLinkActive="active">
                        <i class="fal fa-briefcase" matTooltip="Advertiser"></i>
                        <span>Advertiser</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/orders" routerLinkActive="active">
                        <i class="fal fa-bullhorn" matTooltip="Campaigns"></i>
                        <span>Campaigns</span>
                      </a>
                    </li>
                    <li class="dxk-nav-route-probe"><a routerLink="/line-items" routerLinkActive="active" tabindex="-1" aria-hidden="true"></a></li>
                    <!-- Hidden for now (Line Items) - uncomment to restore
                    <li>
                      <a routerLinkActive="active" routerLink="/line-items">
                        <i class="fal fa-list-ul" matTooltip="Line Items"></i>
                        <span>Line Items</span>
                      </a>
                    </li> -->
                    <li>
                      <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                        routerLinkActive="active">
                        <i class="fal fa-images" matTooltip="Campaigns creative library"></i>
                        <span>Creatives</span>
                      </a>
                    </li>
                    <li>
                      <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_MODERATION_QUEUE]"
                        routerLinkActive="active">
                        <i class="fal fa-clipboard-check" matTooltip="Creative review queue"></i>
                        <span>Review Queue</span>
                      </a>
                    </li>
                  </ul>
                </mat-expansion-panel>
              }
              @if (UI.isNetworkUser) {
                <div (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels()">
                  <a class="sidenav-menu-item" routerLink="/reports" routerLinkActive="active">
                    <span class="nav-icon nav-icon--analytics" matTooltip="Report builder"></span>
                    <span>Reporting</span>
                  </a>
                </div>
              }
<!-- Hidden for now (A2V sidebar entry) - uncomment to restore
              @if (UI.isNetworkUser) {
                <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="sidenav-menu-item" >
                      <i class="fal fa-tv-music" matTooltip="Audio to Video"></i>
                      <span>A2V</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                    <li>
                      <a routerLink="/assets" routerLinkActive="active">
                        <i class="fal fa-folder-open" matTooltip="Assets"></i>
                        <span>Assets</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/brands" routerLinkActive="active">
                        <i class="fal fa-copyright" matTooltip="Brands"></i>
                        <span>Brands</span>
                      </a>
                    </li>
                    <li>
                      <a routerLink="/network-template" routerLinkActive="active">
                        <i class="fal fa-copy" matTooltip="Network Template"></i>
                        <span>Network Template</span>
                      </a>
                    </li>
                  </ul>
                </mat-expansion-panel>
              } -->
              @if (UI.isNetworkUser) {
                <div class="sidenav-menu-stack" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active">
                    <span class="nav-icon nav-icon--changelog" matTooltip="Change Logs"></span>
                    <span>Change Logs</span>
                  </a>
                  <a class="sidenav-menu-item" routerLink="/logs" routerLinkActive="active">
                    <span class="nav-icon nav-icon--logs" matTooltip="System Logs"></span>
                    <span>System Logs</span>
                  </a>
                  <a class="sidenav-menu-item" routerLink="/debug-capture" routerLinkActive="active" *csHasPermission="RolePermission.DEBUG_CAPTURE_MANAGE">
                    <span class="nav-icon nav-icon--debug-capture" matTooltip="Debug Capture"></span>
                    <span>Debug Capture</span>
                  </a>
                </div>
              }
              @if (UI.isNetworkUser) {
                <div (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <a class="sidenav-menu-item" routerLink="/users" routerLinkActive="active">
                    <span class="nav-icon nav-icon--users" matTooltip="Users"></span>
                    <span>Users</span>
                  </a>
                </div>
              }
            </mat-accordion>
          }
          <!--NETWORK USER END-->
          <!-- SALES REPRESENTATIVE USER -->
          @if (UI.isSalesRep) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <div (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
                  <span class="nav-icon nav-icon--dashboard" matTooltip="Dashboard"></span>
                  <span>Dashboard</span>
                </a>
              </div>
              <div *csHasPermission="[RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ]" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                <a class="sidenav-menu-item" routerLink="/ai-insights" routerLinkActive="active">
                  <span class="nav-icon nav-icon--ai-insights" matTooltip="AI Insights"></span>
                  <span>AI Insights</span>
                  <ctv-ai-insights-unread-badge></ctv-ai-insights-unread-badge>
                </a>
              </div>
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item" >
                    <span class="nav-icon nav-icon--supply" matTooltip="Inventory"></span>
                    <span>Inventory</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/apps" routerLinkActive="active">
                      <i class="fal fa-mobile-alt" matTooltip="Apps"></i>
                      <span>Apps</span>
                    </a>
                  </li>
                  <li>
                    <a routerLinkActive="active"
                      routerLink="/ads-txt">
                      <i class="fal fa-file-alt" matTooltip="Ads.txt"></i>
                      <span>Ads.txt</span>
                    </a>
                  </li>
                </ul>
              </mat-expansion-panel>
              <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
                <a class="sidenav-menu-item" routerLink="/publishers" routerLinkActive="active" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <span class="nav-icon nav-icon--publishers" matTooltip="Publishers"></span>
                  <span>Publishers</span>
                </a>
              </div>
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item">
                    <span class="nav-icon nav-icon--analytics"></span>
                    Analytics
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/reports" routerLinkActive="active">
                      <i class="fal fa-chart-bar" matTooltip="Reporting"></i>
                      <span>Report Builder</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/performance" routerLinkActive="active">
                      <i class="fal fa-tachometer-alt" matTooltip="Performance Analyzer"></i>
                      <span>Performance Analyzer</span>
                    </a>
                  </li>
                </ul>
              </mat-expansion-panel>
              <div class="sidenav-menu-stack" (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
                <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <span class="nav-icon nav-icon--changelog" matTooltip="Change Logs"></span>
                  <span>Change Logs</span>
                </a>
                <a class="sidenav-menu-item" routerLink="/logs" routerLinkActive="active" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <span class="nav-icon nav-icon--logs" matTooltip="System Logs"></span>
                  <span>System Logs</span>
                </a>
                <a class="sidenav-menu-item" routerLink="/debug-capture" routerLinkActive="active" *csHasPermission="RolePermission.DEBUG_CAPTURE_MANAGE" (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
                  <span class="nav-icon nav-icon--debug-capture" matTooltip="Debug Capture"></span>
                  <span>Debug Capture</span>
                </a>
              </div>
            </mat-accordion>
          }
          <!-- SALES REPRESENTATIVE USER END-->
          <!-- CAMPAIGN MANAGER / CLIENT SERVICE MANAGER USER -->
          @if (UI.isCampaignManager) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <div *csHasPermission="[RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ]" (click)="closeSidenavMobile(sidenav);">
                <a class="sidenav-menu-item" routerLink="/ai-insights" routerLinkActive="active">
                  <span class="nav-icon nav-icon--ai-insights" matTooltip="AI Insights"></span>
                  <span>AI Insights</span>
                  <ctv-ai-insights-unread-badge></ctv-ai-insights-unread-badge>
                </a>
              </div>
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item" >
                    <span class="nav-icon nav-icon--supply" matTooltip="Inventory"></span>
                    <span>Inventory</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  @if (UI.isCampaignManager) {
                    <li>
                      <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
                        <i class="fal fa-bullseye" matTooltip="Targeting"></i>
                        <span>Targeting</span>
                      </a>
                    </li>
                    <li>
                      <a [routerLink]="['/', AppRoutePath.BLOCK_LIST]" routerLinkActive="active">
                        <i class="fal fa-ban" matTooltip="Block List"></i>
                        <span>Block List</span>
                      </a>
                    </li>
                  }
                </ul>
              </mat-expansion-panel>
              @if (UI.isCampaignManager) {
                <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="sidenav-menu-item">
                      <span class="nav-icon nav-icon--demand"></span>
                      Demand
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                    <li>
                      <a routerLinkActive="active" routerLink="/deals">
                        <i class="fal fa-file-invoice-dollar" matTooltip="Deals"></i>
                        <span>Deals</span>
                      </a>
                    </li>
                  </ul>
                </mat-expansion-panel>
              }
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item">
                    <span class="nav-icon nav-icon--campaign" matTooltip="Campaigns"></span>
                    Campaigns
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/advertiser" routerLinkActive="active">
                      <i class="fal fa-briefcase" matTooltip="Advertisers"></i>
                      <span>Advertisers</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/orders" routerLinkActive="active">
                      <i class="fal fa-bullhorn" matTooltip="Campaigns"></i>
                      <span>Campaigns</span>
                    </a>
                  </li>
                  <li class="dxk-nav-route-probe"><a routerLink="/line-items" routerLinkActive="active" tabindex="-1" aria-hidden="true"></a></li>
                    <!-- Hidden for now (Line Items) - uncomment to restore
                  <li>
                    <a routerLinkActive="active" routerLink="/line-items">
                      <i class="fal fa-list-ul" matTooltip="Line Items"></i>
                      <span>Line Items</span>
                    </a>
                  </li> -->
                  <li>
                    <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                      routerLinkActive="active">
                      <i class="fal fa-images" matTooltip="Campaigns creative library"></i>
                      <span>Creatives</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_MODERATION_QUEUE]"
                      routerLinkActive="active">
                      <i class="fal fa-clipboard-check" matTooltip="Creative review queue"></i>
                      <span>Review Queue</span>
                    </a>
                  </li>
                </ul>
              </mat-expansion-panel>
              <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels()">
                <a class="sidenav-menu-item" routerLink="/reports" routerLinkActive="active">
                  <span class="nav-icon nav-icon--analytics" matTooltip="Report Builder"></span>
                  <span>Report Builder</span>
                </a>
              </div>
            </mat-accordion>
          }
          <!-- CAMPAIGN MANAGER / CLIENT SERVICE MANAGER USER END-->
          <!-- REV OPS -->
          @if (UI.isRevOps) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item" >
                    <span class="nav-icon nav-icon--supply" matTooltip="Inventory"></span>
                    <span>Inventory</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                </ul>
              </mat-expansion-panel>
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item">
                    <span class="nav-icon nav-icon--analytics"></span>
                    Analytics
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/reports" routerLinkActive="active">
                      <i class="fal fa-chart-bar" matTooltip="Reporting"></i>
                      <span>Report Builder</span>
                    </a>
                  </li>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
          }
          <!-- REV OPS END-->
          <!-- DESIGNER -->
          @if (UI.isDesigner) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item">
                    <span class="nav-icon nav-icon--campaign" matTooltip="Campaigns"></span>
                    Campaigns
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                      routerLinkActive="active">
                      <i class="fal fa-images" matTooltip="Campaigns creative library"></i>
                      <span>Creatives</span>
                    </a>
                  </li>
                </ul>
              </mat-expansion-panel>
            </mat-accordion>
          }
          <!-- DESIGNER END-->
          <!-- ADVERTISER (SRS-47) -->
          @if (UI.isAdvertiser) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <div *csHasPermission="[RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ]" (click)="closeSidenavMobile(sidenav);">
                <a class="sidenav-menu-item" routerLink="/ai-insights" routerLinkActive="active">
                  <span class="nav-icon nav-icon--ai-insights" matTooltip="AI Insights"></span>
                  <span>AI Insights</span>
                  <ctv-ai-insights-unread-badge></ctv-ai-insights-unread-badge>
                </a>
              </div>
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item">
                    <span class="nav-icon nav-icon--campaign" matTooltip="Campaigns"></span>
                    Campaigns
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/advertiser" routerLinkActive="active">
                      <i class="fal fa-briefcase" matTooltip="Advertisers"></i>
                      <span>Advertisers</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/orders" routerLinkActive="active">
                      <i class="fal fa-bullhorn" matTooltip="Campaigns"></i>
                      <span>Campaigns</span>
                    </a>
                  </li>
                  <li class="dxk-nav-route-probe"><a routerLink="/line-items" routerLinkActive="active" tabindex="-1" aria-hidden="true"></a></li>
                    <!-- Hidden for now (Line Items) - uncomment to restore
                  <li>
                    <a routerLinkActive="active" routerLink="/line-items">
                      <i class="fal fa-list-ul" matTooltip="Line Items"></i>
                      <span>Line Items</span>
                    </a>
                  </li> -->
                  <li>
                    <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                      routerLinkActive="active">
                      <i class="fal fa-images" matTooltip="Campaigns creative library"></i>
                      <span>Creatives</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_MODERATION_QUEUE]"
                      routerLinkActive="active">
                      <i class="fal fa-clipboard-check" matTooltip="Creative review queue"></i>
                      <span>Review Queue</span>
                    </a>
                  </li>
                </ul>
              </mat-expansion-panel>
              <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels()">
                <a class="sidenav-menu-item" routerLink="/reports" routerLinkActive="active">
                  <span class="nav-icon nav-icon--analytics" matTooltip="Report Builder"></span>
                  <span>Report Builder</span>
                </a>
              </div>
            </mat-accordion>
          }
          <!-- ADVERTISER END-->
          <!-- FINANCE (SRS-47) -->
          @if (UI.isFinance) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <div *csHasPermission="[RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ]" (click)="closeSidenavMobile(sidenav);">
                <a class="sidenav-menu-item" routerLink="/ai-insights" routerLinkActive="active">
                  <span class="nav-icon nav-icon--ai-insights" matTooltip="AI Insights"></span>
                  <span>AI Insights</span>
                  <ctv-ai-insights-unread-badge></ctv-ai-insights-unread-badge>
                </a>
              </div>
              <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item">
                    <span class="nav-icon nav-icon--campaign" matTooltip="Campaigns"></span>
                    Campaigns
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/advertiser" routerLinkActive="active">
                      <i class="fal fa-briefcase" matTooltip="Advertisers"></i>
                      <span>Advertisers</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/orders" routerLinkActive="active">
                      <i class="fal fa-bullhorn" matTooltip="Campaigns"></i>
                      <span>Campaigns</span>
                    </a>
                  </li>
                  <li class="dxk-nav-route-probe"><a routerLink="/line-items" routerLinkActive="active" tabindex="-1" aria-hidden="true"></a></li>
                    <!-- Hidden for now (Line Items) - uncomment to restore
                  <li>
                    <a routerLinkActive="active" routerLink="/line-items">
                      <i class="fal fa-list-ul" matTooltip="Line Items"></i>
                      <span>Line Items</span>
                    </a>
                  </li> -->
                </ul>
              </mat-expansion-panel>
              <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels()">
                <a class="sidenav-menu-item" routerLink="/reports" routerLinkActive="active">
                  <span class="nav-icon nav-icon--analytics" matTooltip="Report Builder"></span>
                  <span>Report Builder</span>
                </a>
              </div>
            </mat-accordion>
          }
          <!-- FINANCE END-->
          <!-- ADMIN USER-->
          @if (UI.isAdmin || UI.isReadonlyAdmin) {
            <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
              <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
                <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
                  <span class="nav-icon nav-icon--dashboard" matTooltip="Dashboard"></span>
                  <span>Dashboard</span>
                </a>
              </div>
              <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
                <a class="sidenav-menu-item" routerLink="/ai-insights" routerLinkActive="active" *csHasPermission="[RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ]">
                  <span class="nav-icon nav-icon--ai-insights" matTooltip="AI Insights"></span>
                  <span>AI Insights</span>
                  <ctv-ai-insights-unread-badge></ctv-ai-insights-unread-badge>
                </a>
              </div>
              <mat-expansion-panel ctvNavSectionGradient *csHasNetworkPermission class="mat-elevation-z0" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="sidenav-menu-item" >
                    <span class="nav-icon nav-icon--supply" matTooltip="Inventory"></span>
                    <span>Inventory</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                  <li>
                    <a routerLink="/placements" routerLinkActive="active">
                      <i class="fal fa-th-large" matTooltip="Placements"></i>
                      <span>Placements</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/audio-supply" routerLinkActive="active">
                      <i class="fal fa-headphones" matTooltip="Audio Supply"></i>
                      <span>Audio Supply</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/display-supply" routerLinkActive="active">
                      <i class="fal fa-desktop" matTooltip="Display Supply"></i>
                      <span>Display Supply</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/supply-search" routerLinkActive="active">
                      <i class="fal fa-search" matTooltip="Supply Search"></i>
                      <span>Supply Search</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/supply-upload" routerLinkActive="active">
                      <i class="fal fa-file-upload" matTooltip="Bulk Upload"></i>
                      <span>Bulk Upload</span>
                    </a>
                  </li>
                  <li>
                    <a routerLink="/apps" routerLinkActive="active">
                      <i class="fal fa-mobile-alt" matTooltip="Apps"></i>
                      <span>Apps</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
                      <i class="fal fa-bullseye" matTooltip="Targeting"></i>
                      <span>Targeting</span>
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/', AppRoutePath.BLOCK_LIST]" routerLinkActive="active">
                      <i class="fal fa-ban" matTooltip="Block List"></i>
                      <span>Block List</span>
                    </a>
                  </li>
                  <li>
                    <a routerLinkActive="active"
                      routerLink="/ads-txt">
                      <i class="fal fa-file-alt" matTooltip="Ads.txt"></i>
                      <span>Ads.txt</span>
                    </a>
                  </li>
                  <li>
                    <a routerLinkActive="active"
                      routerLink="/taxonomy">
                      <i class="fal fa-sitemap" matTooltip="Taxonomy"></i>
                      <span>Taxonomy</span>
                    </a>
                  </li>
                  <!-- <li>
                  <a routerLinkActive="active"
                    routerLink="/marketplace-routing">
                    <i class="fal fa-route" matTooltip="Marketplace Routing"></i>
                    <span>Marketplace Routing</span>
                  </a>
                </li> -->
              </ul>
            </mat-expansion-panel>
            <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" *csHasNetworkPermission [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <span class="nav-icon nav-icon--publishers"></span>
                  Partners
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li>
                  <a routerLink="/publishers" routerLinkActive="active">
                    <i class="fal fa-building" matTooltip="Publishers"></i>
                    <span>Publishers</span>
                  </a>
                </li>
                <li>
                  <a routerLink="/networks" routerLinkActive="active">
                    <i class="fal fa-share-alt" matTooltip="Network"></i>
                    <span>Network</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel>
            <mat-expansion-panel ctvNavSectionGradient *csHasNetworkPermission class="mat-elevation-z0" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <span class="nav-icon nav-icon--demand"></span>
                  Demand
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li>
                  <a routerLinkActive="active" routerLink="/demand/list">
                    <i class="fal fa-handshake" matTooltip="Partners"></i>
                    <span>Partners</span>
                  </a>
                </li>
                <li>
                  <a routerLinkActive="active" routerLink="/connections">
                    <i class="fal fa-plug" matTooltip="Connections"></i>
                    <span>Connections</span>
                  </a>
                </li>
                <li>
                  <a routerLinkActive="active" routerLink="/deals">
                    <i class="fal fa-file-invoice-dollar" matTooltip="Deals"></i>
                    <span>Deals</span>
                  </a>
                </li>
                <li>
                  <a routerLinkActive="active" routerLink="/demand/compliance">
                    <i class="fal fa-clipboard-check" matTooltip="Compliance"></i>
                    <span>Compliance</span>
                  </a>
                </li>
                <li>
                  <a routerLinkActive="active" routerLink="/demand/discrepancies">
                    <i class="fal fa-balance-scale" matTooltip="Discrepancies"></i>
                    <span>Discrepancies</span>
                  </a>
                </li>
                <li>
                  <a routerLinkActive="active" routerLink="/demand/health-settings" *csHasPermission="RolePermission.CONNECTION_HEALTH_MANAGE">
                    <i class="fal fa-heartbeat" matTooltip="Health Settings"></i>
                    <span>Health Settings</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel>
            <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" *csHasNetworkPermission [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <span class="nav-icon nav-icon--campaign" matTooltip="Campaigns"></span>
                  Campaigns
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li>
                  <a routerLink="/advertiser" routerLinkActive="active">
                    <i class="fal fa-briefcase" matTooltip="Advertisers"></i>
                    <span>Advertisers</span>
                  </a>
                </li>
                <li>
                  <a routerLink="/orders" routerLinkActive="active">
                    <i class="fal fa-bullhorn" matTooltip="Campaigns"></i>
                    <span>Campaigns</span>
                  </a>
                </li>
                <li class="dxk-nav-route-probe"><a routerLink="/line-items" routerLinkActive="active" tabindex="-1" aria-hidden="true"></a></li>
                    <!-- Hidden for now (Line Items) - uncomment to restore
                <li>
                  <a routerLinkActive="active" routerLink="/line-items">
                    <i class="fal fa-list-ul" matTooltip="Line Items"></i>
                    <span>Line Items</span>
                  </a>
                </li> -->
                <li>
                  <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                    routerLinkActive="active">
                    <i class="fal fa-images" matTooltip="Campaigns creative library"></i>
                    <span>Creatives</span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_MODERATION_QUEUE]"
                    routerLinkActive="active">
                    <i class="fal fa-clipboard-check" matTooltip="Creative review queue"></i>
                    <span>Review Queue</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel>
<!-- Hidden for now (Moments sidebar entry) - uncomment to restore
            <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false" *csHasNetworkPermission>
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item" routerLink="/sources">
                  <i class="fal fa-users-class" matTooltip="Apps"></i>
                  Moments
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li>
                  <a routerLink="/sources" routerLinkActive="active">
                    <i class="fal fa-broadcast-tower" matTooltip="Sources"></i>
                    <span>Sources</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel> -->
            <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false" *csHasNetworkPermission>
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <span class="nav-icon nav-icon--analytics"></span>
                  Analytics
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li>
                  <a routerLink="/reports" routerLinkActive="active">
                    <i class="fal fa-chart-bar" matTooltip="Reporting"></i>
                    <span>Report Builder</span>
                  </a>
                </li>
                <li>
                  <a routerLink="/performance" routerLinkActive="active">
                    <i class="fal fa-tachometer-alt" matTooltip="Performance Analyzer"></i>
                    <span>Performance Analyzer</span>
                  </a>
                </li>
                <li>
                  <a routerLink="/scheduled-reports" routerLinkActive="active" *csHasPermission="RolePermission.RB_SCHEDULE_CREATE">
                    <i class="fal fa-calendar-alt" matTooltip="Scheduled reports"></i>
                    <span>Scheduled Reports</span>
                  </a>
                </li>
                <!-- Decided to remove on 09/06/2022 by Martin, Dario and Bogdan-->
                <!--<li *csHasNetworkPermission>
                <a routerLink="/custom-reports" routerLinkActive="active" *csHasPermission="RolePermission.CUSTOM_REPORTS_CREATE">
                  <i class="fal fa-file-chart-line" matTooltip="Custom Reports"></i>
                  <span>Custom Reports</span>
                </a>
              </li>-->
              <!-- <li>
              <a [routerLink]="['/', AppRoutePath.ERRORS]" routerLinkActive="active">
                <i class="fal fa-exclamation-triangle" matTooltip="Errors"></i>
                <span>Error Reports</span>
              </a>
            </li> -->
          </ul>
        </mat-expansion-panel>
<!-- Hidden for now (A2V sidebar entry) - uncomment to restore
        <mat-expansion-panel ctvNavSectionGradient *csHasNetworkPermission class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item" >
              <i class="fal fa-tv-music" matTooltip="Audio to Video"></i>
              <span>A2V</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/assets" routerLinkActive="active">
                <i class="fal fa-folder-open" matTooltip="Assets"></i>
                <span>Assets</span>
              </a>
            </li>
            <li>
              <a routerLink="/brands" routerLinkActive="active">
                <i class="fal fa-copyright" matTooltip="Brands"></i>
                <span>Brands</span>
              </a>
            </li>
            <li>
              <a routerLink="/network-template" routerLinkActive="active">
                <i class="fal fa-copy" matTooltip="Network Template"></i>
                <span>Network Template</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel> -->
        <div class="sidenav-menu-stack" *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item" routerLink="/changelog" routerLinkActive="active">
            <span class="nav-icon nav-icon--changelog" matTooltip="Change Logs"></span>
            <span>Change Logs</span>
          </a>
          <a class="sidenav-menu-item" routerLink="/logs" routerLinkActive="active">
            <span class="nav-icon nav-icon--logs" matTooltip="System Logs"></span>
            <span>System Logs</span>
          </a>
          <a class="sidenav-menu-item" routerLink="/debug-capture" routerLinkActive="active" *csHasPermission="RolePermission.DEBUG_CAPTURE_MANAGE">
            <span class="nav-icon nav-icon--debug-capture" matTooltip="Debug Capture"></span>
            <span>Debug Capture</span>
          </a>
        </div>
<!-- Hidden for now (Content sidebar entry) - uncomment to restore
        <mat-expansion-panel ctvNavSectionGradient class="mat-elevation-z0" [expanded]="false" *csHasNetworkPermission>
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="fal fa-file-video"></i>
              Content
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li>
              <a routerLink="/owned-operated-apps" routerLinkActive="active">
                <i class="fal fa-tv" matTooltip="O&O Apps"></i>
                <span>O&O Apps</span>
              </a>
            </li>
            <li>
              <a routerLink="/collections" routerLinkActive="active">
                <i class="fal fa-layer-group" matTooltip="Collections"></i>
                <span>Collections</span>
              </a>
            </li>
            <li>
              <a routerLink="/videos" routerLinkActive="active">
                <i class="fal fa-play-circle" matTooltip="Videos"></i>
                <span>Videos</span>
              </a>
            </li>
            <li>
              <a routerLinkActive="active" routerLink="/content-owner">
                <i class="fal fa-user-tie" matTooltip="Content Owners"></i>
                <span>Content Owners</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel> -->
        <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
          <a class="sidenav-menu-item"  routerLink="/users" routerLinkActive="active">
            <span class="nav-icon nav-icon--users" matTooltip="Users"></span>
            <span>Users</span>
          </a>
        </div>
      </mat-accordion>
    }
    <!-- ADMIN USER END-->
  </div>
  <div class="sidenav-footer" (click)="$event.stopPropagation()">
    <button class="sidenav-footer-avatar" [matMenuTriggerFor]="menu">{{getShortName(user.name)}}</button>
    <div class="sidenav-footer-info">
      <span class="sidenav-footer-name">{{user.name}}</span>
      <span class="sidenav-footer-role">{{user.roles}}</span>
    </div>
  </div>
</mat-sidenav>
}
</mat-sidenav-container>
